import { _ } from '@ngx-translate/core';
import {
  LoyaltyRequestChangeDtoAdd,
  LoyaltyRequestChangeDtoView,
  LoyaltyRequestDtoFullView,
  LoyaltyRequestDtoShortView,
} from '@src/api';

export type RequestListItemType = LoyaltyRequestDtoShortView;

export interface ProductRequestType extends LoyaltyRequestDtoFullView {
  newComment?: LoyaltyRequestChangeDtoAdd;
}

export type ProductRequestChangesType = LoyaltyRequestChangeDtoAdd & LoyaltyRequestChangeDtoView;

export interface StatusType {
  id: number;
  value: string;
}

export const STATUS_TYPE: StatusType[] = [
  { id: 1, value: _('components.lpProductRequest.labels.statusAtWork') },
  { id: 2, value: _('components.lpProductRequest.labels.statusComplete') },
];
